import type { TunnistusState } from "../store/auth";
import { getApiRoot, getWebClientId } from "./config";
import { getJsonResponse } from "./jsonResponse";

export const signupUserPost = (
  receiverEmail: string,
  receiverMobile: string,
  locale: string,
  tunnistusData: TunnistusState,
) =>
  fetch(`${getApiRoot()}/signup/user`, {
    method: "POST",
    body: JSON.stringify({
      receiver_email: receiverEmail,
      receiver_mobile: receiverMobile,
      receiver_ssn: tunnistusData.ssn,
      receiver_info_source: tunnistusData.infoSource,
      receiver_given_name: tunnistusData.givenName,
      receiver_last_name: tunnistusData.lastName,
      signature: tunnistusData.signature,
      language: locale.slice(0, 2),
      affiliate_code: "", // keep empty
      client_id: getWebClientId(),
    }),
    headers: {
      "Content-Type": "application/json",
      "X-skip-clickable-email": `true`,
    },
  }).then(getJsonResponse);

export interface AccessTokenResponse {
  access_token: string;
  resource_owner: string;
  state?: string;
}

export const signupUserOtpPost = (
  receiverEmail: string,
  receiverMobile: string,
  locale: string,
  tunnistusData: TunnistusState,
  otp: string,
): Promise<AccessTokenResponse> =>
  fetch(`${getApiRoot()}/signup/user`, {
    method: "POST",
    body: JSON.stringify({
      receiver_email: receiverEmail,
      receiver_mobile: receiverMobile,
      receiver_ssn: tunnistusData.ssn,
      receiver_info_source: tunnistusData.infoSource,
      receiver_given_name: tunnistusData.givenName,
      receiver_last_name: tunnistusData.lastName,
      signature: tunnistusData.signature,
      language: locale.slice(0, 2),
      otp,
      affiliate_code: "", // keep empty
      client_id: getWebClientId(),
    }),
    headers: {
      "Content-Type": "application/json",
      "X-skip-clickable-email": `true`,
    },
  }).then(getJsonResponse);
